import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslationData } from '@monorepo/interfaces';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MultiTranslationLoader implements TranslateLoader {
    private readonly http = inject(HttpClient);

    public getTranslation(lang: string): Observable<TranslationData> {
        return forkJoin({
            main: this.http.get<TranslationData>(`/assets/i18n/${lang}.json`),
            workflowConfig: this.http.get<TranslationData>(`/assets/i18n/workflow-config-${lang}.json`)
        }).pipe(
            map(translations => ({
                ...translations.main,
                ...translations.workflowConfig
            }))
        );
    }
}
